<script>
import tableComp from "@/compositions/modules/table";
import SrTblColumn from "@/components/SrTblColumn";
import { components } from "@libs/ui";
import { ref, reactive, toRefs } from "vue";
import { fetchPayment, listByAcctName } from "@/api/modules/list";
import { formatMoney } from "@/utils";
import formComp from "@/compositions/modules/form";
import { PaymentReq } from "@/domain/modules/list";
import { useI18n } from "@/plugins/i18n";
import { dataUtils } from "@libs/utils";
import {  vab } from "@libs/utils"
import { RSP_ITEM_TYPE } from '@/domain/base'
import { curEnum, fxTxnStatus, fxStatTag} from "@/domain/modules/client-options"
import { downloadFile } from "@/utils/download";
import { list } from '@/api/url'
export default {
  components: {
    SrTblColumn,
    SrTblPagination: components.SrTblPagination,
  },
  setup() {
    const scopedStates = reactive({
      emptyImg: require("@/assets/img/dashboard/empty.png"),
    });
    const { t } = useI18n();
    const _initTable = initTable();
    const downloadList = async () => {
      await downloadFile(list.paymentExport, _initTable.formReq.fields)
    }
    return { t, ...toRefs(scopedStates), ...toRefs(_initTable), dataUtils, downloadList };
  },
};

const initTable = () => {
  const { t } = useI18n();
  const { createTable } = tableComp();
  const _initForm = initForm();
  const columnsTemp = [
    { prop: 'txnNo', label: t("trade.table.text_10"), align: 'left' },
    { slot: "acctId", align: "left", label: t("trade.table.text_2") },
    { prop: "inviteCode", label: t('dashboard.table.text_7') },
    { prop: "buyAmt", label: t("trade.table.text_3"), type: RSP_ITEM_TYPE.AMOUNT, depend: 'buyCur', align: "right" },
    { prop: "sellAmt", label: t("trade.table.text_5"), type: RSP_ITEM_TYPE.AMOUNT, depend: 'sellCur', align: "right" },
    // { prop: "feeAmt", label: t("trade.table.text_9"), type: RSP_ITEM_TYPE.AMOUNT, depend: 'sellCur', align: "right" },
    { slot: 'acctStat', label: t('trade.table.text_12') },
    { slot: "sysTxnDatetime", label: t("trade.table.text_7"), width: "240px", headerSlot: 'sysTxnDatetimeHeader', align: "center" },
    {
      slot: "completeDate",
      label: t("trade.table.text_8"),
      width: "240px",
      align: "center",
      headerSlot: 'completeDatetime'
    },
    // { prop: 'transAmt', label: '交易金额折美' },
    // { prop: 'txnNo', label: '交易编号' },
    // { prop: 'regDate', align: 'right', label: '开户日期' },
  ];
  const acctStatEnum = {
    '02,03': t('dict.fxTxnStatus.02'),
    '04,05': t('dict.fxTxnStatus.04'),
    '09': t('dict.fxTxnStatus.09'),
  }
  const tbl = createTable({ columns: columnsTemp });
  const scopedMethods = {
    fetchData: async () => {
      const params = {
        pageInfo: {
          current: tbl.pagination.currentPage,
          size: tbl.pagination.pageSize,
        },
        acctId: _initForm.formReq.fields.acctId || "",
        inviteCode: _initForm.formReq.fields.inviteCode || "",
        sellCur: _initForm.formReq.fields.sellCur || '',
        completeDate: _initForm.formReq.fields.completeDate || [],
        sysTxnDate: _initForm.formReq.fields.sysTxnDate || [],
        txnStatusList: _initForm.formReq.fields.txnStatusList ? _initForm.formReq.fields.txnStatusList.split(',') : [],
      };
      // if (!scopedMethods.checkParam(params)) {
      //   return;
      // }

      tbl.data.loading = true;
      tbl.data.list = [];
      try {
        const res = await fetchPayment(params);
        tbl.data.list = res.list.map((item) => ({
          ...item,
          sellAmt: formatMoney(item.sellAmt),
          buyAmt: formatMoney(item.buyAmt),
          transAmt: formatMoney(item.transAmt),
          sysTxnDatetime: dataUtils.formatDate(
            item.sysTxnDatetime,
            "YYYY-MM-DD HH:mm:ss"
          ),
          completeDatetime: dataUtils.formatDate(
            item.completeDatetime,
            "YYYY-MM-DD HH:mm:ss"
          ),
        }));
        tbl.pagination.total = res.pageInfo.total;
      } finally {
        tbl.data.loading = false;
      }
    },
    checkParam(param) {
      let res = true;
      if (!param.acctId ) {
        let date = param.sysTxnDate;
        if ((date && date[0])) {
          let nowDate = new Date();
          let limit = new Date(nowDate.setDate(nowDate.getDate() - 90));
          if (date && new Date(date[0]) < limit) {
            vab.baseMessage("交易完成日期请选择90天以内的日期搜索","error")
            
            return false;
          }
        } else {
          vab.baseMessage("请选择客户或选择90天以内的交易完成日期搜索","error")
          
          return false;
        }
      }

      return res;
    },
  };
  scopedMethods.fetchData()
  return { tbl, ..._initForm, ...scopedMethods, curEnum, acctStatEnum, fxTxnStatus, fxStatTag};
};

// 初始化form
const initForm = () => {
  const { createForm } = formComp();
  const scopedState = reactive({
    formReq: createForm({ items: PaymentReq }),
  });
  let nowDate = new Date();
  let limit = new Date(nowDate.setDate(nowDate.getDate() - 90));
  scopedState.formReq.fields.sysTxnDate = [dataUtils.formatDate(limit,"YYYY-MM-DD"),dataUtils.formatDate(new Date(),"YYYY-MM-DD")]

  // 处理下拉框
  let selectList = ref([]);
  const scopedMethods = {
    // 处理下拉框
    handleSelect: async (e) => {
      const res = await listByAcctName({ acctName: e });
      selectList.value = res.list.map((item) => ({
        ...item,
        label: item.acctName,
        value: item.acctId,
      }));
    },
  };
  return { ...scopedMethods, ...scopedState, selectList };
};
</script>

<template>
  <div class="table-container">
    <div class="h1">{{t('enum.text_4')}}</div>
    <div class="sr-container__content sr-container__content--row">
      <el-form :model="formReq.fields"
        inline
        :label-width="localCN?'100px':'160px'"
        label-position="left">
        <el-form-item :label="formReq.schema.acctName.label">
          <el-select v-model="formReq.fields.acctId"
            filterable
            remote
            clearable
            :remote-method="e=>handleSelect(e)">
            <el-option v-for="item in selectList"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item :label="formReq.schema.inviteCode.label">
          <el-input v-model="formReq.fields.inviteCode" :placeholder="formReq.schema.inviteCode.placeholder" />
        </el-form-item>
        <el-form-item :label="formReq.schema.sellCur.label">
          <el-select v-model="formReq.fields.sellCur" clearable>
            <el-option v-for="item in curEnum"
              :label="item"
              :value="item"
              :key="item" />
          </el-select>
        </el-form-item>
        <el-form-item :label="formReq.schema.txnStatusList.label">
          <el-select v-model="formReq.fields.txnStatusList" clearable :placeholder="formReq.schema.txnStatusList.placeholder">
            <el-option v-for="(value,key) in acctStatEnum" :key="key" :label="value" :value="key" />
          </el-select>
        </el-form-item>

        <el-form-item :label="formReq.schema.sysTxnDate.label">
          <el-date-picker v-model="formReq.fields.sysTxnDate"
            style="width: 240px"
            type="daterange"
            unlink-panels
            range-separator="-"
            value-format="YYYY-MM-DD"
            :start-placeholder="t('components.datepicker.start')"
            :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="formReq.schema.completeDate.label">
          <el-date-picker v-model="formReq.fields.completeDate"
            style="width: 240px"
            type="daterange"
            unlink-panels
            range-separator="-"
            value-format="YYYY-MM-DD"
            :start-placeholder="t('components.datepicker.start')"
            :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
            @click="fetchData">{{t('client.content.text_1')}}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadList">{{t('client.content.text_6')}}</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <el-table row-class-name="row-con"
      :data="tbl.data.list"
      v-loading="tbl.data.loading">
      <sr-tbl-column :columns="tbl.columns">
        <template #acctId="scope">
          <div >
            <div>{{scope.row.acctName}}</div>
            <div>{{scope.row.acctId}}</div>
          </div>
        </template>
        <template #sysTxnDatetimeHeader>
          <div class="header-cell">
            <span>{{ t("trade.table.text_7") }}</span>
            <el-tooltip effect="dark" placement="top">
              <template #content>
                {{ t("trade.tips.text_1") }}
              </template>
              <el-icon><InfoFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
        <template #sysTxnDatetime="scope">
          <div>
            <div>{{ dataUtils.formatDate(scope.row.sysTxnDatetime, "YYYY-MM-DD") }}</div>
            <div>{{ dataUtils.formatDate(scope.row.sysTxnDatetime, "HH:mm:ss")}}</div>
          </div>
        </template>
        <template #acctStat="scope">
          <div class="header-cell">
            <el-tag v-if="scope.row.txnStatus" :type="fxStatTag[scope.row.txnStatus]">
              {{fxTxnStatus[scope.row.txnStatus]}}
            </el-tag>
            <span v-else>-</span>
          </div>
        </template>
        <template #completeDatetime>
          <div class="header-cell">
            <span>{{  t("trade.table.text_8")}}</span>
            <el-tooltip effect="dark" placement="top">
              <template #content>
                {{ t("trade.tips.text_2") }}
              </template>
              <el-icon><InfoFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
        <template #completeDate="scope">
          <div v-if="scope.row.completeDatetime">
            <div>{{ dataUtils.formatDate(scope.row.completeDatetime, "YYYY-MM-DD") }}</div>
            <div>{{ dataUtils.formatDate(scope.row.completeDatetime, "HH:mm:ss")}}</div>
          </div>
          <div v-else>-</div>
        </template>
      </sr-tbl-column>
      <template #empty>
        <div class="empty-wrap">
          <img :src="emptyImg"
            alt="">
          {{t('collection.content.text_2')}}
        </div>
      </template>
    </el-table>
    <sr-tbl-pagination v-model:current-page="tbl.pagination.currentPage"
      v-model:page-size="tbl.pagination.pageSize"
      :total="tbl.pagination.total"
      @fetchData="fetchData">
    </sr-tbl-pagination>
  </div>
</template>

<style lang="scss" scoped rel="stylesheet/scss">
.header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  padding: 30px 20px;

  .empty-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 160px auto;
    box-sizing: border-box;

    & > img {
      width: 190px;
      height: auto;
      display: block;
      margin-bottom: 38px;
    }
  }

  :deep(.row-con) {
    height: 57px;
  }
}
</style>
